import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import InventoryLocationServices from '@Services/settings/inventoryLocationServices';
import InventoryLocationActions, { inventoryLocationsTypes } from '@Actions/settings/inventoryLocationActions';

/**
 * @param action
 */
function* _getInventoryLocation(action) {
  try {
    yield put(InventoryLocationActions.getInventoryLocationsLoading(true));
    const {
      tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId,
    } = action;
    const inventoryLocations = yield InventoryLocationServices.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId);
    yield put(InventoryLocationActions.getInventoryLocationsSuccess(inventoryLocations));
    if (action.callback) {
      action.callback(inventoryLocations);
    }
    yield put(InventoryLocationActions.getInventoryLocationsLoading(false));
  } catch (error) {
    yield put(InventoryLocationActions.getInventoryLocationsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(inventoryLocationsTypes.GET_INVENTORY_LOCATIONS.ERROR, error));
  }
}

/**
 *
 */
function* getInventoryLocation() {
  yield takeLatest(inventoryLocationsTypes.GET_INVENTORY_LOCATIONS.REQUEST, _getInventoryLocation);
}
/**
 * @param action
 */
function* _createInventoryLocation(action) {
  try {
    yield put(InventoryLocationActions.createInventoryLocationLoading(true));
    const inventoryLocation = yield InventoryLocationServices.createInventoryLocation(action.payload);
    if (inventoryLocation.success) {
      yield put(TrackerActions.trackAction(inventoryLocationsTypes.CREATE_INVENTORY_LOCATION.SUCCESS, inventoryLocation.data));
      notification.open({
        type: 'success',
        message: 'inventory location successfully created',
        duration: 4,
        placement: 'top',
      });
      yield put(InventoryLocationActions.createInventoryLocationLoading(false));
      if (action.callback) {
        action.callback(inventoryLocation);
      }
    } else {
      notification.open({
        type: 'error',
        message: inventoryLocation?.error,
        duration: 4,
        placement: 'top',
      });
      yield put(InventoryLocationActions.createInventoryLocationLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.error,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(inventoryLocationsTypes.CREATE_INVENTORY_LOCATION.ERROR, error));
    yield put(InventoryLocationActions.createInventoryLocationLoading(false));
  }
}

/**
 *
 */
function* createInventoryLocation() {
  yield takeLatest(inventoryLocationsTypes.CREATE_INVENTORY_LOCATION.REQUEST, _createInventoryLocation);
}

/**
 *
 * @param {*} action
 */
function* _updateInventoryLocation(action) {
  try {
    yield put(InventoryLocationActions.updateInventoryLocationLoading(true));
    const inventoryLocation = yield InventoryLocationServices.updateInventoryLocation(action.payload);
    if (inventoryLocation.success) {
      yield put(TrackerActions.trackAction(inventoryLocationsTypes.UPDATE_INVENTORY_LOCATION.SUCCESS, inventoryLocation.data));
      notification.open({
        type: 'success',
        message: 'inventory location updated successfully',
        duration: 4,
        placement: 'top',
      });
      yield put(InventoryLocationActions.updateInventoryLocationLoading(false));
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: inventoryLocation?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(InventoryLocationActions.updateInventoryLocationLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(inventoryLocationsTypes.UPDATE_INVENTORY_LOCATION.ERROR, error));
    yield put(InventoryLocationActions.updateInventoryLocationLoading(false));
  }
}

/**
 *
 */
function* updateInventoryLocation() {
  yield takeLatest(inventoryLocationsTypes.UPDATE_INVENTORY_LOCATION.REQUEST, _updateInventoryLocation);
}

/**
 * @param action
 */
function* _deleteInventoryLocation(action) {
  try {
    yield put(InventoryLocationActions.deleteInventoryLocationLoading(true));
    const deletedPo = yield InventoryLocationServices.deleteInventoryLocation(action.payload);
    if (deletedPo.success) {
      notification.open({
        type: 'success',
        message: 'Location has been deleted.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedPo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InventoryLocationActions.deleteInventoryLocationLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(inventoryLocationsTypes.DELETE_INVENTORY_LOCATION.ERROR, error));
    yield put(InventoryLocationActions.deleteInventoryLocationLoading(false));
  }
}

/**
 *
 */
function* deleteInventoryLocation() {
  yield takeLatest(inventoryLocationsTypes.DELETE_INVENTORY_LOCATION.REQUEST, _deleteInventoryLocation);
}

/**
 *
 */
export default function* inventoryLocationSaga() {
  yield all([
    getInventoryLocation(), createInventoryLocation(), updateInventoryLocation(), deleteInventoryLocation(),
  ]);
}
